module.exports = __webpack_public_path__ + "static/media/5_un.7d19b3e9.svg";